import { useState } from "react";

import Report from "./components/Report";

const BetInquiry = () => {
  const [activeTab, setActiveTab] = useState("report");

  return (
    <div>
      <Report activeTab={activeTab} />
    </div>
  );
};

export default BetInquiry;
